
define('models/browserDetect',[],function() {
	
	return Backbone.Model.extend({
		
		initialize: function() {
			// http://stackoverflow.com/questions/5916900/detect-version-of-browser
			var ua= navigator.userAgent, 
			    N= navigator.appName, tem, 
			    M= ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*([\d\.]+)/i) || [];
				
		    M= M[2]? [M[1], M[2]]:[N, navigator.appVersion, '-?'];
		    if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];

			this.browser = M;
			
			if(this.browser[0].toLowerCase() == "safari")
				this.browser[1] = this.browser[2];
		},
		
		hasAtLeast: function(list) {
			
			for(var i in list) {
				var requirement = list[i].split(" ");
				
				// If we catch a browser with a version thats too old.
				if(	requirement[0].toLowerCase() == this.browser[0].toLowerCase() && 
					requirement[1] && this.browser[1] && 
					parseInt(requirement[1]) > parseInt(this.browser[1])
				) {
					return false;
				}
			}
				
			return true;
			
		},
		
		isIE: function() {
			return this.browser[0].toLowerCase() == "msie" || this.browser[0].toLowerCase() == "trident";
		},
		
		iOS: function() {
			if (/iP(hone|od|ad)/.test(navigator.platform)) {
				// supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
				var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
			}
			
		}
		
		
	});
	
	
});